var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1083 7.89063L7.89166 12.1073C7.35 11.5656 7.01666 10.824 7.01666 9.99896C7.01666 8.34896 8.35 7.01562 10 7.01562C10.825 7.01562 11.5667 7.34896 12.1083 7.89063Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 4.80937C13.3917 3.70937 11.725 3.10938 9.99999 3.10938C7.05832 3.10938 4.31666 4.84271 2.40833 7.84271C1.65833 9.01771 1.65833 10.9927 2.40833 12.1677C3.06666 13.201 3.83332 14.0927 4.66666 14.8094",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01666 16.276C7.96666 16.676 8.975 16.8927 10 16.8927C12.9417 16.8927 15.6833 15.1594 17.5917 12.1594C18.3417 10.9844 18.3417 9.00937 17.5917 7.83437C17.3167 7.40104 17.0167 6.99271 16.7083 6.60938",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.925 10.582C12.7083 11.757 11.75 12.7154 10.575 12.932",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89169 12.1094L1.66669 18.3344",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 1.66797L12.1083 7.89297",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.e6b08e81a0a9d2b86f3f5332db7f2b28.svg";
export { ForwardRef as ReactComponent };